/**
 * "Zadaj nam pytanie" popup on szkolenia product pages.
 * Opens/closes the native <dialog>. The form inside is Contact Form 7,
 * which handles its own validation, submission and (via the global
 * wpcf7_before_send_mail hook) the optional MailerLite sign-up.
 */
export default class AskQuestion {
    constructor() {
        this.root = document.querySelector('.jsAskQuestionDialog');

        if (!this.root) return;

        this.trigger = document.querySelector('.jsAskQuestionTrigger');
        this.closeBtn = this.root.querySelector('.jsAskQuestionDialogClose');
        this.pointerDownOnBackdrop = false;

        this.events();
    }

    events() {
        if (this.trigger) {
            this.trigger.addEventListener('click', () => this.root.showModal());
        }

        if (this.closeBtn) {
            this.closeBtn.addEventListener('click', () => this.root.close());
        }

        // Close on backdrop click. Track the press on mousedown so dragging a
        // text selection from inside the form onto the backdrop won't close it.
        this.root.addEventListener('mousedown', (e) => {
            this.pointerDownOnBackdrop =
                e.target === this.root && this.isOnBackdrop(e);
        });

        this.root.addEventListener('click', (e) => {
            const closeIt =
                this.pointerDownOnBackdrop &&
                e.target === this.root &&
                this.isOnBackdrop(e);

            this.pointerDownOnBackdrop = false;

            if (closeIt) this.root.close();
        });
    }

    /**
     * True when the pointer is outside the dialog's box (i.e. over the
     * ::backdrop), not on its padding/content. Uses the rendered rect so the
     * dialog's own padding still counts as "inside".
     */
    isOnBackdrop(e) {
        const r = this.root.getBoundingClientRect();
        return (
            e.clientX < r.left ||
            e.clientX > r.right ||
            e.clientY < r.top ||
            e.clientY > r.bottom
        );
    }
}
